module.exports = __webpack_public_path__ + "img/client-premco-precast.3cb9fcde.jpeg";